import React from 'react';
import { CheckCircle2Icon, PlayIcon } from 'lucide-react';
export function FinalCTA() {
  const steps = ['Haz clic en "¡Sí! Quiero Acceso Instantáneo"', 'Completa tu pedido', 'Obtén acceso inmediato al sistema, plantillas y bonos', 'Publica tu primer video viral hoy mismo'];
  return <section className="w-full px-4 py-16 md:py-20 bg-gradient-to-b from-slate-900 to-purple-900" data-id="element-22">
      <div className="max-w-4xl mx-auto" data-id="element-23">
        <h2 className="text-3xl md:text-5xl font-bold text-white text-center mb-10 leading-tight" data-id="element-24">
          Lo que debes hacer ahora:
        </h2>
        <div className="bg-slate-800/50 border border-slate-700 rounded-2xl p-6 md:p-8 mb-8" data-id="element-25">
          <div className="space-y-6 md:space-y-8" data-id="element-26">
            {steps.map((step, index) => <div key={index} className="flex items-start gap-4 md:gap-6" data-id="element-27">
                <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 bg-purple-600 rounded-full flex items-center justify-center" data-id="element-28">
                  <span className="text-white font-bold text-lg md:text-xl" data-id="element-29">
                    {index + 1}
                  </span>
                </div>
                <p className="text-base md:text-xl text-gray-200 pt-1 md:pt-2" data-id="element-30">
                  {step}
                </p>
              </div>)}
          </div>
        </div>
        <div className="bg-gradient-to-br from-purple-600 to-pink-600 rounded-2xl p-6 md:p-10 text-center" data-id="element-31">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jM2FmQn6bJKwJteVFq2ziB/VVM_5_BOXES.png" alt="Viral Video Machine IA" className="w-full max-w-md mx-auto rounded-xl shadow-2xl mb-6" data-id="element-32" />
          <p className="text-xl md:text-2xl font-bold text-white mb-6 leading-tight" data-id="element-33">
            ¿Listo para crear videos virales en 60 minutos?
          </p>
          <a href="https://www.voicesoffreedomus.com/cart/45295821488314:1" className="block w-full px-6 md:px-8 py-5 bg-white hover:bg-gray-100 text-purple-600 rounded-lg shadow-xl hover:shadow-2xl transition-all duration-300 mb-6" data-id="element-34">
            <div className="text-lg md:text-xl font-bold leading-tight mb-1" data-id="element-35">
              Obtén Acceso Instantáneo
            </div>
            <div className="text-2xl md:text-3xl font-extrabold leading-tight" data-id="element-36">
              Por Solo $17
            </div>
          </a>
          <div className="flex flex-col sm:flex-row justify-center items-center gap-3 md:gap-4 text-sm md:text-base text-purple-100" data-id="element-37">
            <div className="flex items-center gap-2" data-id="element-38">
              <CheckCircle2Icon className="w-4 h-4 md:w-5 md:h-5" data-id="element-39" />
              <span data-id="element-40">Acceso Inmediato</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-41">
              <CheckCircle2Icon className="w-4 h-4 md:w-5 md:h-5" data-id="element-42" />
              <span data-id="element-43">Garantía de 30 Días</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-44">
              <CheckCircle2Icon className="w-4 h-4 md:w-5 md:h-5" data-id="element-45" />
              <span data-id="element-46">Pago Único</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}